import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import NinegridImg from "../../assets/images/ninegrid-logo.png";
// import TotvsImg from "../../assets/images/totvs-logo.png";
import TotvsBlackImg from "../../assets/images/logo-totvs-black.png";
import TotvsWhiteImg from "../../assets/images/logo-totvs-white.png";
import NinegridBlackImg from "../../assets/images/logo-ninegrid-black.png";
import NinegridWhiteImg from "../../assets/images/logo-ninegrid-white.png";
import { MainButton } from "../../components/MainButton";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import InputMask from "react-input-mask";
import { Loading } from "../../components/Loading";

import "./index.css";
import Swal from "sweetalert2";
import { useSeller } from "../../hooks/useSeller";
import { Input } from "../../components/Input/Input";
import { usePluginspace } from "../../hooks/usePluginspace";

import { useBiometricAuthSeller } from "../../hooks/useBiometricAuthSeller";
import { decodeToken } from "react-jwt";

export function SellerLogin() {
  const navigate = useNavigate();
  const params = useParams();
  const { getAppConfig } = useAppConfig();
  const { registerAccess, getToken } = usePluginspace();
  const [config, setConfig] = useState<ConfigType | void>();

  const [isInitializing, setIsInitializing] = useState(true);
  const [loading, setLoading] = useState(false);

  const [logged, setLogged] = useState(false);

  const [sellerIdentifier, setSellerIdentifier] = useState("");
  const [sellerEmail, setSellerEmail] = useState("");
  const [sellerPassword, setSellerPassword] = useState("");

  const [alarmIdentifier, setAlarmIdentifier] = useState(false);
  const [alarmLogin, setAlarmLogin] = useState(false);
  const [alarmPassword, setAlarmPassword] = useState(false);

  const [maskCpf, setMaskCpf] = useState("999.999.999-99");

  const { sellerLogin, getSellerUser } = useSeller();

  const { biometriaDisponivel, offerBiometricSetup, loginWithBiometric } =
    useBiometricAuthSeller({
      pluginspaceId: params.pluginspace_id,
      getToken,
      config,
      setLoading,
      onBiometricLoginSuccess: async (loginVerifyPayload, documentUsed) => {
        const token =
          loginVerifyPayload.data.token || loginVerifyPayload.data.accessToken;

        const tkNoSalt = process.env.REACT_APP_JWT_SALT
          ? token.split(process.env.REACT_APP_JWT_SALT).join("")
          : token;
        const tk: any = decodeToken(tkNoSalt);

        if (tk && documentUsed === tk.identifier) {
          localStorage.setItem("seller-tk", token);
          await getSellerUser();
          toCategory();
        } else {
          throw new Error(
            "O CPF da biometria não corresponde ao usuário autenticado.",
          );
        }
      },
    });

  useEffect(() => {
    registerAccess("seller");
    getConfig();
    localStorage.removeItem("seller-tk");
  }, [params]);

  async function getConfig() {
    setConfig(await getAppConfig());
    setIsInitializing(false);
  }

  function toCategory() {
    navigate(`/${params.pluginspace_id}/category`);
  }

  async function loginSeller() {
    setLoading(true);
    const pluginspaceName = atob(params.pluginspace_id!);

    const loginResult = await sellerLogin(
      sellerEmail,
      sellerPassword,
      sellerIdentifier,
      pluginspaceName,
    );

    if (loginResult) {
      const sellerTk = localStorage.getItem("seller-tk");
      if (biometriaDisponivel && sellerTk && process.env.REACT_APP_JWT_SALT) {
        const tkNoSalt = sellerTk
          .split(process.env.REACT_APP_JWT_SALT)
          .join("");
        const tkData: any = decodeToken(tkNoSalt);

        if (tkData?.id) {
          await offerBiometricSetup(sellerTk, tkData.id, sellerIdentifier);
        }
      }

      setLoading(false);
      toCategory();
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro - Dados Inválidos",
        text: "Seu email ou senha estão incorretos. Revise e tente novamente",
      });
    }
  }

  return (
    <div className="home" style={{ position: "relative" }}>
      {" "}
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent white background
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 100, // On top of everything
          }}
        >
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      )}
      {isInitializing ? (
        <div style={{ width: "100%", height: "calc(100vh)" }}>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div
          className="content-home"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            ...(config?.background
              ? {
                  backgroundImage: `url(${config?.background})`,
                  backgroundSize: "cover",
                }
              : {}),
            opacity: loading ? 0.6 : 1,
            transition: "opacity 0.2s ease-in-out",
          }}
        >
          <div className="logo-home">
            {config?.img && <img src={config.img} alt="Logo" />}
          </div>

          <div className="actions-home">
            <div
              style={{
                pointerEvents: loading ? "none" : "auto",
                width: "100%",
              }}
            >
              {logged ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbuttonhome
                      ? config.webappcolor.fontbuttonhome
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.backgroundbuttonhome
                      ? config.webappcolor.backgroundbuttonhome
                      : "#EAEAEA"
                  }
                  text="Entrar"
                  onClick={toCategory}
                />
              ) : (
                <div className="form-seller">
                  <div className="title-form">
                    <h2>Acesso do vendedor</h2>
                  </div>
                  <div className="inputs">
                    <div>
                      <InputMask
                        mask={maskCpf}
                        type="text"
                        placeholder="CPF"
                        value={sellerIdentifier}
                        disabled={loading}
                        onChange={(event) =>
                          setSellerIdentifier(event.target.value)
                        }
                        onBlur={() =>
                          sellerIdentifier[1] === "_"
                            ? setAlarmIdentifier(true)
                            : setAlarmIdentifier(false)
                        }
                      />
                      {alarmIdentifier && (
                        <p className="alarm-text">Informe um CPF</p>
                      )}
                    </div>
                    <div>
                      <input
                        placeholder="Login"
                        type="email"
                        value={sellerEmail}
                        disabled={loading}
                        onChange={(event) => setSellerEmail(event.target.value)}
                        onBlur={() =>
                          sellerEmail === ""
                            ? setAlarmLogin(true)
                            : setAlarmLogin(false)
                        }
                      />
                      {alarmLogin && (
                        <p className="alarm-text">Informe o login</p>
                      )}
                    </div>
                    <div>
                      <Input
                        inputAttr={{
                          type: "password",
                          name: "password",
                          autoComplete: "off",
                          disabled: loading,
                        }}
                        label="Senha"
                        placeholder="Senha"
                        value={sellerPassword}
                        change={setSellerPassword}
                      />
                      {alarmPassword && (
                        <p className="alarm-text">Informe a senha</p>
                      )}
                    </div>
                  </div>
                  <div className="footer">
                    <MainButton
                      color={
                        config?.webappcolor.fontbutton
                          ? config.webappcolor.fontbutton
                          : "#636363"
                      }
                      backgroundColor={
                        config?.webappcolor.webappbutton
                          ? config.webappcolor.webappbutton
                          : "#EAEAEA"
                      }
                      text={loading ? "Aguarde..." : "Continuar"}
                      onClick={loginSeller}
                    />

                    {biometriaDisponivel && (
                      <MainButton
                        color={
                          config?.webappcolor.fontbutton
                            ? config.webappcolor.fontbutton
                            : "#636363"
                        }
                        backgroundColor={
                          config?.webappcolor.webappbutton
                            ? config.webappcolor.webappbutton
                            : "#EAEAEA"
                        }
                        text={loading ? "Aguarde..." : "Entrar com Biometria"}
                        onClick={() => loginWithBiometric(sellerIdentifier)}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="footer-home">
            {config?.content.useLogoTotvs && (
              <img
                src={
                  config &&
                  config.content &&
                  config.content.colorLogo === "white"
                    ? TotvsWhiteImg
                    : TotvsBlackImg
                }
                alt="TOTVS"
                className="totvs-img"
              />
            )}
            {config?.content.useLogoTotvs && (
              <h2
                style={{
                  color:
                    config &&
                    config.content &&
                    config.content.colorLogo === "white"
                      ? "white"
                      : "black",
                }}
              >
                by
              </h2>
            )}
            <img
              src={
                config && config.content && config.content.colorLogo === "white"
                  ? NinegridWhiteImg
                  : NinegridBlackImg
              }
              alt="Ninegrid by pluginbot"
              className="ninegrid-img"
            />
          </div>
        </div>
      )}
    </div>
  );
}
